import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { api, apiError } from '@/lib/api';
import { useAuthStore } from '@/lib/auth-store';
export function LoginPage() {
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(null);
    const navigate = useNavigate();
    const setSession = useAuthStore((s) => s.setSession);
    const onFinish = async (values) => {
        setLoading(true);
        setErr(null);
        try {
            const { data } = await api.post('/auth/login', values);
            setSession({
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
                user: data.user,
            });
            navigate('/', { replace: true });
        }
        catch (e) {
            setErr(apiError(e));
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx("div", { style: {
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            padding: '16px',
            paddingTop: 'calc(16px + env(safe-area-inset-top))',
            paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
            background: 'radial-gradient(circle at 20% 20%, #7F1D1D 0%, #1F1B1A 55%, #100D0C 100%)',
        }, children: _jsx(Card, { style: {
                width: '100%',
                maxWidth: 400,
                borderRadius: 14,
                boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                border: '1px solid rgba(255,255,255,0.06)',
            }, children: _jsxs(Space, { direction: "vertical", size: "middle", style: { width: '100%' }, children: [_jsxs("div", { style: { textAlign: 'center' }, children: [_jsx("div", { style: {
                                    width: 56,
                                    height: 56,
                                    margin: '0 auto 12px',
                                    borderRadius: 14,
                                    background: '#B91C1C',
                                    color: '#FEF3C7',
                                    display: 'grid',
                                    placeItems: 'center',
                                    fontFamily: 'Georgia, serif',
                                    fontWeight: 700,
                                    fontSize: 22,
                                }, children: "HBT" }), _jsx(Typography.Title, { level: 4, style: { margin: 0 }, children: "HBT Pekanbaru" }), _jsx(Typography.Text, { type: "secondary", children: "Aplikasi Akuntansi" })] }), err && _jsx(Alert, { type: "error", showIcon: true, message: err, closable: true }), _jsxs(Form, { layout: "vertical", onFinish: onFinish, autoComplete: "off", children: [_jsx(Form.Item, { name: "username", label: "Username", rules: [{ required: true, message: 'Username wajib diisi' }], children: _jsx(Input, { prefix: _jsx(UserOutlined, {}), placeholder: "admin", size: "large", autoFocus: true }) }), _jsx(Form.Item, { name: "password", label: "Password", rules: [{ required: true, message: 'Password wajib diisi' }], children: _jsx(Input.Password, { prefix: _jsx(LockOutlined, {}), placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", size: "large" }) }), _jsx(Button, { type: "primary", htmlType: "submit", loading: loading, block: true, size: "large", children: "Masuk" })] })] }) }) }));
}
